import { IUser } from '@gig/magic-sdk/dist/adapter/users/user';
import { Language } from '@gig/magic-sdk/dist/adapter/users/language';

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        _smartico_user_id: string | null;
        _smartico_language: string | null;
        _smartico: any;
    }
}

export class SmarticoService {
    /**
     * This method is responsible for setting the user's ID and language
     * on the global window object for the Smartico script to read.
     */
    public setUserData(user: IUser | null, lang: Language | null) {
        window._smartico_user_id = user ? String(user.id) : null;
        window._smartico_language = user ? lang : null;
    }

    /**
     * This method opens the Smartico gamification widget.
     * It should be called when the user clicks the corresponding menu item.
     */
    public async openGamificationWidget() {
        if (window._smartico) {
            window._smartico.dp('dp:gf');
        } else {
            console.warn(
                'Smartico widget function (_smartico.dp) not available. Cannot open widget.',
            );
        }
    }
}

export const smarticoService = new SmarticoService();
